<template>
  <component
    :is="getComponentName()"
    :is-opened="isOpened"
    class="slider-refuse-proposal"
    @close="close"
  >
    <template #header>
      &nbsp;
    </template>
    <template #body>
      <div class="slider-refuse-proposal-header">
        {{ title }}
      </div>
      <div class="slider-refuse-proposal-content">
        <div class="slider-refuse-proposal-content__panel">
          <Panel
            :title="panelTitle"
            :content="panelContent"
            :account-manager="payload.accountManager"
            :type="panelType"
          />
        </div>
        <div class="slider-refuse-proposal-content__choices">
          <ul>
            <li
              v-for="reason in reasons"
              :key="reason.choice"
              class="input-checkbox"
            >
              <input
                :id="`reason_${reason.id}`"
                v-model="checkedReasons"
                type="checkbox"
                :value="reason.choice"
              >
              <label
                :for="`reason_${reason.id}`"
              ><span>{{ reason.choice }}</span></label>
            </li>
          </ul>
        </div>
        <div class="slider-refuse-proposal-content__label-textarea">
          {{ trans('sliders.refuse_proposal.textarea_label') }}
        </div>
        <div class="input-text">
          <textarea
            v-model="refuseTextareaContent"
            :placeholder="trans('sliders.refuse_proposal.textarea_placeholder')"
          />
        </div>
      </div>
    </template>

    <template #footer>
      <div class="slider-refuse-proposal-ctas">
        <button class="btn btn--secondary" @click="close">
          {{ trans('sliders.refuse_proposal.cta_cancel') }}
        </button>
        <button
          class="btn btn--primary"
          :disabled="isCTADisabled"
          @click="refuseProposal"
        >
          {{ trans('sliders.refuse_proposal.cta_send') }}
        </button>
      </div>
    </template>
  </component>
</template>

<script>
import { flashBagSuccess } from '../../../_00_elements/tools/flashbag';
import translation from '../../../_00_elements/translation';
import eventBus from '../../../_00_elements/tools/event-bus';
import SlideIn from '../../../_01_atoms/components/Slidein.vue';
import SliderUp from '../../../_01_atoms/components/Sliderup.vue';
import Panel from '../Panel.vue';
import { OFFER_EVENT } from '../../../_03_organisms/offer/constants';

export default {
  components: { Panel, SlideIn, SliderUp },
  mixins: [ translation ],
  props: {
    isOpened: { type: Boolean, required: true },
    payload: { type: Object, default: () => {} },
  },
  data() {
    return {
      title: this.trans('sliders.refuse_proposal.title'),
      panelType: 'info-lightest',
      panelTitle: this.trans('slider.refuse_proposal.panel.title'),
      panelContent: this.trans('slider.refuse_proposal.panel.content'),
      refuseTextareaContent: '',
      reasons: this.generateReasons(),
      checkedReasons: [],
    };
  },
  computed: {
    isCTADisabled() {
      return this.checkedReasons.length === 0 && this.refuseTextareaContent.trim() === '';
    },
  },
  mounted() {
    eventBus.addEventListener(OFFER_EVENT.PROPOSAL_REFUSE, this.onProposalRefuse);
  },
  methods: {
    getComponentName() {
      return document.body.classList.contains('is-mobile') ? 'slider-up' : 'slide-in';
    },
    generateReasons() {
      let id = 0;
      const reasons = [
        'refuse_proposal.price',
        'refuse_proposal.location',
        'refuse_proposal.space',
        'refuse_proposal.style',
        'refuse_proposal.typology',
        'refuse_proposal.conditions',
        'refuse_proposal.already_in_touch',
      ];
      const arrayReasons = [];

      reasons.forEach((v) => {
        arrayReasons.push({ id: id++, choice: this.trans(v) });
      });

      return arrayReasons;
    },
    getAllRefusedReasons() {
      if (this.refuseTextareaContent) {
        this.checkedReasons.push(this.trans('refuse_proposal.comment') + this.refuseTextareaContent);
      }
    },
    refuseProposal() {
      this.getAllRefusedReasons();

      eventBus.dispatchEvent(
        new CustomEvent(OFFER_EVENT.PROPOSAL_OFFER_REMOVE, {
          detail: {
            proposalId: this.payload.id,
            refusalReasons: this.checkedReasons,
          },
        }),
      );

      this.close();
      this.refuseTextareaContent = '';
      this.checkedReasons = [];
    },
    onProposalRefuse() {
      flashBagSuccess(this.trans('slider.refuse_proposal.flashbag_success'));
    },
    close() {
      this.$emit('close');

      eventBus.dispatchEvent(
        new CustomEvent(OFFER_EVENT.PROPOSAL_REMOVE_LOADER, {
          detail: { proposalId: this.payload.id },
        }),
      );
    },
  },
};
</script>
